import { ReviewerRequest, ReviewerResponse, ManuscriptAuthor, AuthorProfile } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5084/api';
const API_KEY = process.env.REACT_APP_API_KEY || 'your-secret-api-key-here';

export class ApiService {
  static async searchReviewers(abstractText: string, manuscriptAuthors: ManuscriptAuthor[], countryFilter?: string, excludeSameInstitution?: boolean, maxPerInstitution?: number | null): Promise<ReviewerResponse> {
    try {
      const request: ReviewerRequest = { abstractText, manuscriptAuthors, countryFilter, excludeSameInstitution, maxPerInstitution };
      
      const response = await fetch(`${API_BASE_URL}/reviewers/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': API_KEY,
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.errorMessage || `HTTP error! status: ${response.status}`);
      }

      const data: ReviewerResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error searching for reviewers:', error);
      return {
        authors: [],
        success: false,
        errorMessage: error instanceof Error ? error.message : 'An unexpected error occurred',
      };
    }
  }

  static async getAuthorProfile(authorId: string): Promise<AuthorProfile | null> {
    try {
      const response = await fetch(`${API_BASE_URL}/reviewers/${authorId}/profile`, {
        method: 'GET',
        headers: {
          'X-Api-Key': API_KEY,
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.errorMessage || `HTTP error! status: ${response.status}`);
      }

      const data: AuthorProfile = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching author profile for ${authorId}:`, error);
      throw error; // Re-throw to be handled by the caller
    }
  }
} 